import * as React from 'react';

interface IBalloonProps {
	color: string;
	size: number;
}

const Balloon = (props: IBalloonProps) => <span style={{ background: props.color, width: props.size, height: props.size, borderRadius: '50%' }} />

export default Balloon;
